import { STATS } from "../data/site";
import { motion } from "framer-motion";

export default function Stats() {
  return (
    <section className="bg-mm-surface border-b border-mm-green/15" data-testid="stats-section">
      <div className="mx-auto max-w-[1400px] grid grid-cols-2 md:grid-cols-5">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="group px-6 py-10 sm:py-14 border-r border-b md:border-b-0 border-mm-green/15 last:border-r-0 hover:bg-mm-panel transition-colors duration-300"
          >
            <div className="font-heading font-black text-5xl sm:text-6xl text-white group-hover:text-mm-green transition-colors duration-300 tracking-tight">
              {s.value}
            </div>
            <div className="mt-2 font-mono text-[11px] tracking-[0.2em] uppercase text-gray-400">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
